import React from 'react'
import './index.styl'

export default function Groups () {
  return (
  <div className="groups">
    Groups
  </div>)
}

